import { xMean } from 'ml-spectra-processing';
/**
 * Center the mean
 * @param data
 */
export function centerMean(data) {
    const { y } = data;
    const mean = xMean(y);
    for (let i = 0; i < y.length; i++) {
        y[i] -= mean;
    }
    return { data };
}
//# sourceMappingURL=centerMean.js.map